/**
 * Wrapper to video component
 */

import React, { Component } from "react";

import _ from "lodash";

import Video from "../Video/index";
import ForwardArrow from "../../assets/svg/arrow-forward.svg";
import TvgLogoWhite from "../../assets/images/tvg-logo-white.svg";
import Tvg2LogoWhite from "../../assets/images/tvg2-logo-white.svg";
import VideoIcon from "../../assets/svg/mtp-wvideo.svg";
import style from "./style.css";

/* eslint-disable */

/* eslint-enable */

// flow is stupid and made me do these two types

/* eslint-enable */

const DROPSIDE_HEIGHT = 360;
/**
 * show tvg channel icon
 */
const renderChannel = (channel) => {
  switch (channel) {
    case "1":
      return <TvgLogoWhite width="40" />;
    case "2":
      return <Tvg2LogoWhite width="50" />;
    default:
      return null;
  }
};

const calcUpsideDown = (event) => {
  const clickY = event.clientY;
  const viewPortHeight =
    document.documentElement &&
    Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

  return clickY + DROPSIDE_HEIGHT > parseInt(viewPortHeight, 10);
};

const calcDropSideHeight = (event) => {
  const target = event.currentTarget;
  const lhnTabsHeader = document.querySelector("#tabsWrapperHeader");
  const headerHeight = lhnTabsHeader ? lhnTabsHeader.clientHeight : 0;
  const eventData = event && target;
  const thisButtonHeight = eventData ? target.clientHeight : 0;
  const isUpsideDown = calcUpsideDown(event);

  const totalOffset = isUpsideDown
    ? thisButtonHeight + DROPSIDE_HEIGHT - 26
    : thisButtonHeight + 4 + Math.floor(headerHeight / 2);
  return eventData
    ? event.currentTarget.getBoundingClientRect().top - totalOffset
    : 0;
};

/**
 * TVG Video Wrapper Component
 *
 * This component will encapsulate the video component and will add it some interactions.
 * will allow to change live Tracks, go too betSlip, Show Login container and popout video
 *
 */
export default class VideoWrapper extends Component {
  /** ---- Component Types ---- */

  static defaultProps = {
    hasTracks: false
  };

  constructor(props) {
    super(props);
    _.bindAll(this, [
      "getVideoStream",
      "getHeader",
      "getLoggedInRender",
      "renderHeaderLabelSelectedTrack",
      "renderHeaderLabelNextRace",
      "showHideDropdown",
      "getLogoutRender",
      "selectVideoRace",
      "handleCallback"
    ]);

    this.state = {
      selectedTrack: props.selectedTrack,
      isFlash: props.isFlash,
      isLogged: props.isLogged
    };
  }

  state;

  componentWillReceiveProps(nextProps) {
    const selectedTrack =
      this.state.selectedTrack !== nextProps.selectedTrack
        ? nextProps.selectedTrack
        : this.state.selectedTrack;

    this.setState({
      isFlash: nextProps.isFlash,
      isLogged: nextProps.isLogged,
      selectedTrack
    });
  }

  /**
   * Render Video Component
   */
  getVideoStream() {
    if (this.state.selectedTrack) {
      return (
        <div className={style.videoContainer}>
          <Video
            videoClass={style.videoStyle}
            streamName={this.state.selectedTrack.streamName}
            isFlash={this.state.isFlash}
            isHD={this.state.selectedTrack.isHD}
            userLoggedIn={this.state.isLogged}
            onPopOut={this.props.onPopOut}
          />
        </div>
      );
    }
    return (
      <div className={style.videoContainer}>
        <div className={style.disableOverlay}>
          <VideoIcon />
        </div>
      </div>
    );
  }

  /**
   * Render Header component
   */
  getHeader() {
    let headerLabel = (
      <span className={style.headerLabel}>
        {this.props.hasTracks ? "NO TRACK SELECTED" : "NO AVAILABLE TRACKS"}
      </span>
    );

    if (_.get(this.state, "selectedTrack.nextRace")) {
      headerLabel = this.renderHeaderLabelNextRace();
    } else if (_.get(this.state, "selectedTrack")) {
      headerLabel = this.renderHeaderLabelSelectedTrack();
    }
    return <div className={style.header}>{headerLabel}</div>;
  }

  /**
   * Render logged in container
   */
  getLoggedInRender() {
    return (
      <div className={style.videoWrapper}>
        {this.getHeader()}
        {this.getVideoStream()}
      </div>
    );
  }

  /**
   * Render logged out container
   */
  getLogoutRender() {
    return (
      <button
        className={style.loginVideoWrapper}
        onClick={(e) => this.handleCallback(e, this.props.loginCallback)}
      >
        <div className={style.overlay}>
          <VideoIcon />
          <p className={style.loginLabel}>
            Please,
            <span className={style.loginLink}>Log in</span>
            to watch videos
          </p>
        </div>
      </button>
    );
  }

  /**
   * Select Video Race
   */
  selectVideoRace(track) {
    this.setState({
      selectedTrack: track
    });
  }

  /**
   * Handle function callback
   */
  handleCallback(event, callback) {
    if (event) {
      event.preventDefault();
    }

    if (callback) {
      callback(this.state.selectedTrack);
    }
  }

  props;

  /**
   * show and hide track dropDown list
   */
  showHideDropdown(event) {
    const videoPlayerId = this.props.id;
    const topValue = event ? calcDropSideHeight(event) : 0;
    const upsideDownFlag = event ? calcUpsideDown(event) : false;

    this.props.toggleDropDownCallback(videoPlayerId, topValue, upsideDownFlag);
  }

  /**
   * This will render header next race
   */
  renderHeaderLabelNextRace() {
    if (!this.state.selectedTrack) {
      return null;
    }
    return (
      <span className={style.headerLabel}>
        {this.state.selectedTrack.name}
        <ForwardArrow className={style.arrow} />
      </span>
    );
  }

  /**
   * This will render header selected track
   */
  renderHeaderLabelSelectedTrack() {
    if (!this.state.selectedTrack) {
      return null;
    }
    return (
      <div className={style.headerLabel}>
        <span className={style.liveOn}>Live on</span>
        {_.get(this.state, "selectedTrack.channel")
          ? renderChannel(this.state.selectedTrack.channel)
          : null}
      </div>
    );
  }

  render() {
    if (this.state.isLogged) {
      return this.getLoggedInRender();
    }
    return this.getLogoutRender();
  }
}
